import {
    Box,
    FormControlLabel,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow
} from '@mui/material';
import { getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import DashboardVoteListTable from 'app/components/Table/DashboardVoteListTable';
import CustomTooltip from 'app/components/Tooltip/CustomTooltip';
import { getSubjectName, sortByProperty, stripHTMLTags } from 'app/utils/appHelpers';
import { DECISION, MEETING_USER, STATUS_REVIEW, VOTE } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { ViewList } from '@mui/icons-material';
import { setCurrentMeetingUsers } from 'stores/meeting';


function DecisionStatusListDataTableCard({ mainData, afterUpdateFunc }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState(mainData);
    const subjectList = useSelector((state) => state.subject.data || []);
    const dispatch = useDispatch();
    const { authUser } = useSelector((state) => state.auth);

    // Not: Backend artık statusReview toplu alanlarını güvenli ayırıcı (|||) ile döndürüyor.
    // Bu yüzden info metninde virgül olsa bile split(',') yapıp metni kesmiyoruz.
    const STATUS_SEPARATOR = '|||';

    const handleSwitchChange = async (e, record) => {

        const newStatus = e.target.checked ? 1 : 0;
        const apiResponse = await putUpdateObjectApi(DECISION, { id: record.id, status: newStatus }, "status"); // decision tablosundaki status guncelleme



        if (apiResponse.status) {
            const dstatusObj = {
                userId: authUser.id,
                info: newStatus === 0
                    ? "Sistem notu: Bilgi notu girilmemiştir(Uygulanmadı olarak işaretlenmiştir)"
                    : "Sistem notu: Bilgi girilmemiştir(Uygulandı olarak işaretlenmiştir)",
                decisionId: record?.id,
                meetingId: record?.meetingId,

            };
            const apiResponse2 = await postSaveObjectApi(STATUS_REVIEW, dstatusObj); // status_review tablosuna yeni kayit ekleme
            if (apiResponse2.status) {
                const newReviewId = apiResponse2.data.insertId;
                const currentDateStr = new Date().toISOString();

                const target = data.find((item) => item.id === record.id) || {};
                const newUserStatusId = target.userStatusId && target.userStatusId.trim()
                    ? `${newReviewId}${STATUS_SEPARATOR}${target.userStatusId}`
                    : `${newReviewId}`;
                const newUserStatusInfo = target.userStatusInfo && target.userStatusInfo.trim()
                    ? `${dstatusObj.info}${STATUS_SEPARATOR}${target.userStatusInfo}`
                    : dstatusObj.info;
                const newUserStatusPdate = target.userStatusPdate && target.userStatusPdate.trim()
                    ? `${currentDateStr}${STATUS_SEPARATOR}${target.userStatusPdate}`
                    : currentDateStr;
                const newStatusReviewUserIds = target.statusReviewUserIds && target.statusReviewUserIds.trim()
                    ? `${authUser.id}${STATUS_SEPARATOR}${target.statusReviewUserIds}`
                    : `${authUser.id}`;

                const updatedFields = {
                    status: newStatus,
                    userStatusId: newUserStatusId,
                    userStatusInfo: newUserStatusInfo,
                    userStatusPdate: newUserStatusPdate,
                    statusReviewUserIds: newStatusReviewUserIds,
                };

                const updatedData = data.map((item) =>
                    item.id === record.id ? { ...item, ...updatedFields } : item
                );
                setData([...updatedData]);

                afterUpdateFunc(updatedFields, record.id);

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: `Karar durumu ${newStatus === 1 ? 'uygulandı' : 'uygulanmadı'} olarak güncellendi.`,
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        popup: 'swal2-popup',
                    },
                });
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: `Karar durumu güncellenemedi.`,
                showConfirmButton: false,
                timer: 2000,
            });
        }
        const swalModal = document.querySelector('.swal2-container');
        if (swalModal) {
            swalModal.style.zIndex = '9999';
        }
    };

    const columns = [
        { id: 'decisionNo', label: 'Karar No', align: 'center' },
        { id: 'department', label: 'İlgili Kurum/Birim', align: 'center' },
        { id: 'subject', label: 'Konu', align: 'left' },
        { id: 'agenda', label: 'Gündem', align: 'left' },
        { id: 'decision', label: 'Karar', align: 'left' },
        { id: 'vte', label: 'Oy Durumları', align: 'left' },
        { id: 'status', label: 'Uygulanma Durumu', align: 'center' },
    ];

    const [agendaVoteList, setAgendaVoteList] = useState([]);
    useEffect(() => {
        const getAPI = async () => {
            if (mainData !== undefined && mainData.length > 0) {

                const res = await getObjectListByPropertyApi(VOTE, "decisionId", mainData[0].id);
                setAgendaVoteList(res.data)


                let res3 = await getObjectListByPropertyApi(MEETING_USER, "meetingId", mainData[0].meetingId)

                let data = res3.data.filter(item => item.type === 1)
                data = sortByProperty(data, "indexNo")
                dispatch(setCurrentMeetingUsers(data));


            }
        }
        getAPI();
    }, [mainData.id])




    return (
        <Paper className="col-md-12" sx={{ minWidth: 0, overflow: 'hidden' }}>
            <div className="flex-auto" style={{ minWidth: 0 }}>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table
                        sx={{
                            minWidth: 960,
                            width: '100%',
                            tableLayout: 'auto',
                            '& th, & td': { fontSize: '12px' },
                            '& .MuiTableCell-head': { whiteSpace: 'normal' },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} sx={{ whiteSpace: 'normal' }}>
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((n) => (
                                    <TableRow hover key={n.id}>
                                        <TableCell align="center">{n.decisionNo}</TableCell>
                                        <TableCell align="center">{n.department}</TableCell>
                                        <TableCell align="left">
                                            {getSubjectName(n.subjectId, subjectList)}
                                        </TableCell>
                                        <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{stripHTMLTags(n.agenda)}</TableCell>
                                        <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{stripHTMLTags(n.decision)}</TableCell>
                                        <TableCell align="left">

                                            <CustomTooltip
                                                placement="bottom"
                                                arrow
                                                title={
                                                    <React.Fragment>
                                                        <div style={{
                                                            width: '100%',
                                                            maxWidth: '600px',
                                                            maxHeight: '500px',
                                                            overflowY: 'auto'
                                                        }}>
                                                            <DashboardVoteListTable otherScroll="true" agendaVotes={agendaVoteList} type="dstatusCard" />
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            >

                                                <ViewList color='warning' />
                                            </CustomTooltip>

                                        </TableCell>

                                        <TableCell align="center">
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={n.status === 1}
                                                        onChange={(e) => handleSwitchChange(e, n)}
                                                    />
                                                }
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50]}
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(event, newPage) => setPage(newPage)}
                                    onRowsPerPageChange={(event) => {
                                        setRowsPerPage(parseInt(event.target.value, 10));
                                        setPage(0);
                                    }}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Box>
            </div>
        </Paper>
    );
}

export default DecisionStatusListDataTableCard;
